import styled from 'styled-components';

export const IconContainer = styled.form``;

export const Heading = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodyLargeSemibold}
  margin-top: 20px;
  text-align: center;
`;

export const Description = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  color: ${(props) => props.theme.newPalette.neutral.N600};
  margin-top: 20px;
  text-align: center;
`;
